import { Table } from '@flos/react-ui';
import type { CoverageDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import CoverageTableRow from '../CoverageTable/CoverageTableRow';
import { getDeductiblesText, processBodyTerms } from '../../utils/termsUtil';
import { useHippoText } from '../../hooks/useHippoText';

const IncludedCoverages = ({
    includedCoverages,
    showCoverableDetailsUI,
    shouldRenderTitle = false,
    flavourName,
    coverableId
}: {
    shouldRenderTitle?: boolean;
    showCoverableDetailsUI: boolean;
    includedCoverages: CoverageDTO[] | undefined;
    flavourName: string;
    coverableId: string;
}): React.JSX.Element => {
    const getHippoText = useHippoText();

    return (
        <div className="included-coverages-container">
            {shouldRenderTitle && (
                <div className="u-display-flex@xs u-flex-justify-between@xs">
                    <h4>{getHippoText('DSS-SHOPPING-BASKET-SELECTED-COVERAGES-TITLE')}</h4>
                </div>
            )}
            <Table mobileDirection={showCoverableDetailsUI ? 'horizontal' : 'vertical'}>
                <Table.Body>
                    {includedCoverages?.map((coverage) => {
                        const includedCoverageTerms = processBodyTerms(
                            coverage?.terms ?? [{}],
                            flavourName
                        );
                        const { mainDeductibles, secondaryDeductibles } = includedCoverageTerms;
                        const deductibleTerms = mainDeductibles.concat(secondaryDeductibles);
                        return (
                            <CoverageTableRow
                                coverage={coverage}
                                iconProps={
                                    !showCoverableDetailsUI
                                        ? {
                                              shape: 'circle-check',
                                              className: 'has-fill is-green'
                                          }
                                        : undefined
                                }
                                deductibleText={getDeductiblesText(
                                    coverage,
                                    mainDeductibles,
                                    secondaryDeductibles
                                )}
                                key={coverage.name}
                                deductibleTerms={deductibleTerms}
                                shouldAlignTextLeft={showCoverableDetailsUI}
                                showEarlierEffectiveDates={showCoverableDetailsUI}
                            />
                        );
                    })}
                </Table.Body>
            </Table>
        </div>
    );
};

export default IncludedCoverages;
